import React, { useEffect, useState } from 'react';
import './Footer.css';
import N3rveLogo from './../../images/N3rveLogo.png'
import InstagramLogo from './../../images/instagramlogo.png'
import TwitterLogo from './../../images/twitterlogo.png'
import DiscordLogo from './../../images/discordlogo.png'
import DiscordIcon from './../../images/discordicon.png'
import {useNavigate} from 'react-router-dom'
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import { Cloudinary } from '@cloudinary/url-gen';
import { auto } from '@cloudinary/url-gen/actions/resize';
import { autoGravity } from '@cloudinary/url-gen/qualifiers/gravity';
import { AdvancedImage } from '@cloudinary/react';

function Footer() {
  const {t, i18n } = useTranslation();
  const [dimensions, setDimensions] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  })
  const navigate= useNavigate();
  const cld = new Cloudinary({ cloud: { cloudName: 'ddvootytq' } })
  
  const handleResize = () => {
    console.log(window.innerWidth)
    setDimensions({
    width: window.innerWidth,
    height: window.innerHeight,
    });
  }


  useEffect(()=>{
    window.addEventListener("resize", handleResize,false);
  },[])

  return (
    <div>
      
       {
      // dimensions.width < 768 &&
      //   <div>
      //     <div style={{
      //                 backgroundColor:'#4053E4',
      //                 height:'3.33em'}}>
      //         <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{height:'100%',textDecoration:'none',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
      //         <img src={DiscordIcon} alt="Instagram Logo" style={{height:'1.33em',width:'1.75em',marginRight:'0.68em'}}/>
      //         <div style={{
      //           color:'white',
      //           fontFamily:'ClashGrotesk-Variable,sans-serif',
      //           fontWeight:'500',
      //           fontSize:'1em',
      //           lineHeight:'150%',
      //           letterSpacing:'2.5%'
      //         }}>{t('discordmessage')}</div>
      //         </a>
      //       </div>
          
      //     <div className="FooterContainer" style={{flexDirection:'column'}}>
          
      //     <div style={{display:'flex',flexDirection:'row',justifyContent:'center',alignItems:'center'}}>

      //     <img src={N3rveLogo} alt="Nerve Logo" className='Logo' style={{marginTop:'2.25em'}}/>
        
      //     {/* <div style={{backgroundColor:'#292929',width:'2.5em',height:'2.5em', borderRadius:'999px',display:'flex',alignItems:'center',justifyContent:'center'}}> */}
      //       <img src={InstagramLogo} alt="Instagram Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'2.5em'}}/>
      //       <img src={TwitterLogo} alt="Twitter Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/>
      //       <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}><img src={DiscordLogo} alt="Discord Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/></a>
      //     </div>
      //     <div className='Copywrighttext'>&copy; 2024 N3RVE All Rights Reserved</div>
      //     {/* </div> */}
      //   </div>
        
      // </div>
       }

    {
      dimensions.width < 768 &&
        <div>
           <div style={{
                      backgroundColor:'#4053E4',
                      paddingTop:'0.75em',
                      paddingBottom:'0.75em'}}>
              <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{height:'100%',textDecoration:'none',display:'flex',flexDirection:'column',alignItems:'center',justifyContent:'center'}}>
              <img src={DiscordIcon} alt="Instagram Logo" style={{height:'1.33em',width:'1.75em',marginTop:'0.75em',marginBottom:'0.625em'}}/>
              <div style={{
                color:'white',
                fontFamily:'ClashGrotesk-Variable,sans-serif',
                fontWeight:'500',
                fontSize:'1em',
                lineHeight:'150%',
                letterSpacing:'2.5%'
              }}>{t('discordmessage')}</div>
              </a>
            </div>
          
          <div className="FooterContainer">

            <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',justifyContent:'flex-start',marginLeft:'1.5em',paddingTop:'2.5em',maxWidth:'90%'}}>
                <div  style={{display:'flex',flexDirection:'column',marginRight:'1em',marginLeft:'1em'}}>
                  <div className='FooterHeaderMob'>ABOUT N3RVE</div>
                  <div className='FooterItem' onClick={()=>navigate('/about')}>About Us</div>
                  <div className='FooterItem' onClick={()=>navigate('/termsconditions')}>Terms & Conditions</div>
                  <div className='FooterItem' onClick={()=>navigate('/privacypolicy')}>Privacy Policy</div>
                  <a href="https://n3rve.ghost.io/private/?r=%2F" target="_blank"  className='FooterItem' style={{textDecoration:'none',maxWidth:'5em'}}><div>Blog</div></a>
                  <div className='FooterItem' onClick={()=>navigate('/support')}>Career</div>
                  <div className='FooterItem' onClick={()=>navigate('/faq')}>FAQ</div>
                </div>

                <div  style={{display:'flex',flexDirection:'column',marginLeft:'2.5em'}}>
                  <div className='FooterHeaderMob'>PRODUCT</div>
                  <div className='FooterItem' onClick={()=>navigate('/Artist')}>For Artist</div>
                  <div className='FooterItem' onClick={()=>navigate('/Producer')}>For Producer</div>
                 <div className='FooterItem' onClick={()=>navigate('/publishing')}>Publishing</div>
                  <div className='FooterItem' onClick={()=>navigate('/monetize')}>Monetization</div>
                  <div className='FooterItem'>Business</div>
                </div>
            </div>

            <div style={{display:'flex',flexDirection:'row',alignSelf:'flex-start',justifyContent:'flex-start',marginLeft:'2.3em',paddingTop:'2.5em',maxWidth:'90%'}}>
                <div  style={{display:'flex',flexDirection:'column',marginRight:'1em'}}>
                  <div className='FooterHeaderMob'>COMMUNITY</div>
                  <div className='FooterItem'>Instagram</div>
                  <div className='FooterItem'>X (Formerly Twitter)</div>
                  <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}><div className='FooterItem'>Discord</div></a>
                </div>

                <div  style={{display:'flex',flexDirection:'column',marginLeft:'2.5em'}}>
                  <div className='FooterHeaderMob'>ACCOUNT SERVICES</div>
                  <div className='FooterItem' onClick={()=>navigate('/Signup')}>Create Account</div>
                  <div className='FooterItem' onClick={()=>navigate('/Login')}>Login</div>
                  <div className='FooterItem' onClick={()=>navigate('/support')}>Contact</div>
                  <div className='FooterItem' onClick={()=>navigate('/help')}>Help</div>
                </div>
            </div>
          
          <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',paddingBottom:'1em',paddingTop:'2.5em'}}>
            <img src={N3rveLogo} alt="Nerve Logo" style={{width:'4.78em',height:'0.875em'}}/>

            <div className='Copywrighttext'>&copy; 2024 N3RVE All Rights Reserved</div>
          
            
           
      
          </div>

          <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',paddingBottom:'5.18em'}}>
            <img src={InstagramLogo} alt="Instagram Logo" style={{height:'2.5em',width:'2.5em'}}/>
            <img src={TwitterLogo} alt="Twitter Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/>
            <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}><img src={DiscordLogo} alt="Discord Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/></a>
          </div>
        </div>
        
      </div>
       }

        {
      dimensions.width >= 768 && dimensions.width <1024 &&
        <div>
         <div style={{
                      backgroundColor:'#4053E4',
                      height:'3.33em'}}>
              <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{height:'100%',textDecoration:'none',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
              <img src={DiscordIcon} alt="Instagram Logo" style={{height:'1.33em',width:'1.75em',marginRight:'0.68em'}}/>
              <div style={{
                color:'white',
                fontFamily:'ClashGrotesk-Variable,sans-serif',
                fontWeight:'500',
                fontSize:'0.875em',
                lineHeight:'150%',
                letterSpacing:'2.5%'
              }}>{t('discordmessage')}</div>
              </a>
            </div>
          
          <div className="FooterContainer">

            <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',paddingTop:'2.5em'}}>
                <div  style={{display:'flex',flexDirection:'column',marginRight:'2em'}}>
                  <div className='FooterHeaderTab'>ABOUT N3RVE</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/about')}>About Us</div>
                  <div className='FooterItemTab'  onClick={()=>navigate('/termsconditions')}>Terms & Conditions</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/privacypolicy')}>Privacy Policy</div>
                  <a href="https://n3rve.ghost.io/private/?r=%2F" target="_blank"  className='FooterItemTab' style={{textDecoration:'none',maxWidth:'5em'}}><div>Blog</div></a>
                  <div className='FooterItemTab' onClick={()=>navigate('/support')}>Career</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/faq')}>FAQ</div>
                </div>

                <div  style={{display:'flex',flexDirection:'column',marginRight:'2em'}}>
                  <div className='FooterHeaderTab'>PRODUCT</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/Artist')}>For Artist</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/Producer')}>For Producer</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/publishing')}>Publishing</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/monetize')}>Monetization</div>
                  <div className='FooterItemTab'>Business</div>
                </div>

                <div  style={{display:'flex',flexDirection:'column',marginRight:'2em'}}>
                  <div className='FooterHeaderTab'>COMMUNITY</div>
                  <div className='FooterItemTab'>Instagram</div>
                  <div className='FooterItemTab'>X (Formerly Twitter)</div>
                  <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}><div className='FooterItemTab'>Discord</div></a>
                </div>

                <div  style={{display:'flex',flexDirection:'column'}}>
                  <div className='FooterHeaderTab'>ACCOUNT SERVICES</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/Signup')}>Create Account</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/Login')}>Login</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/support')}>Contact</div>
                  <div className='FooterItemTab' onClick={()=>navigate('/help')}>Help</div>
                </div>
            </div>
          
          <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',paddingBottom:'2.6em',paddingTop:'2.5em'}}>
            <img src={N3rveLogo} alt="Nerve Logo" style={{width:'4.78em',height:'0.875em'}}/>

            <div className='Copywrighttext'>&copy; 2024 N3RVE All Rights Reserved</div>
          
            
            <img src={InstagramLogo} alt="Instagram Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'2.5em'}}/>
            <img src={TwitterLogo} alt="Twitter Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/>
            <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}><img src={DiscordLogo} alt="Discord Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/></a>
      
           
          </div>
        </div>
        
      </div>
       }

  {
        dimensions.width >=1024 &&
        <div>
          <div style={{
                      backgroundColor:'#4053E4',
                      height:'3.33em'}}>
              <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{height:'100%',textDecoration:'none',display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center'}}>
              <img src={DiscordIcon} alt="Instagram Logo" style={{height:'1.33em',width:'1.75em',marginRight:'0.68em'}}/>
              <div style={{
                color:'white',
                fontFamily:'ClashGrotesk-Variable,sans-serif',
                fontWeight:'500',
                fontSize:'0.875em',
                lineHeight:'150%',
                letterSpacing:'2.5%'
              }}>{t('discordmessage')}</div>
              </a>
            </div>
          
          <div className="FooterContainer">

            <div style={{display:'flex',flexDirection:'row',alignItems:'flex-start',justifyContent:'center',paddingTop:'2.5em'}}>
                <div  style={{display:'flex',flexDirection:'column',marginRight:'4em'}}>
                  <div className='FooterHeader'>About N3RVE</div>
                  <div className='FooterItem' onClick={()=>navigate('/about')}>About Us</div>
                  <div className='FooterItem'  onClick={()=>navigate('/termsconditions')}>Terms & Conditions</div>
                  <div className='FooterItem' onClick={()=>navigate('/privacypolicy')}>Privacy Policy</div>
                  <a href="https://n3rve.ghost.io/private/?r=%2F" target="_blank"  className='FooterItem' style={{textDecoration:'none',maxWidth:'5em'}}><div>Blog</div></a>
                  <div className='FooterItem' onClick={()=>navigate('/support')}>Career</div>
                  <div className='FooterItem' onClick={()=>navigate('/faq')}>FAQ</div>
                </div>

                <div  style={{display:'flex',flexDirection:'column',marginRight:'4em'}}>
                  <div className='FooterHeader'>Product</div>
                  <div className='FooterItem' onClick={()=>navigate('/Artist')}>For Artist</div>
                  <div className='FooterItem' onClick={()=>navigate('/Producer')}>For Producer</div>
                  <div className='FooterItem' onClick={()=>navigate('/publishing')}>Publishing</div>
                  <div className='FooterItem' onClick={()=>navigate('/monetize')}>Monetization</div>
                  <div className='FooterItem'>Business</div>
                </div>

                <div  style={{display:'flex',flexDirection:'column',marginRight:'4em'}}>
                  <div className='FooterHeader'>Community</div>
                  <div className='FooterItem'>Instagram</div>
                  <div className='FooterItem'>X (Formerly Twitter)</div>
                  <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}><div className='FooterItem'>Discord</div></a>
                </div>

                <div  style={{display:'flex',flexDirection:'column'}}>
                  <div className='FooterHeader'>Account Services</div>
                  <div className='FooterItem' onClick={()=>navigate('/Signup')}>Create Account</div>
                  <div className='FooterItem' onClick={()=>navigate('/Login')}>Login</div>
                  <div className='FooterItem' onClick={()=>navigate('/support')}>Contact</div>
                  <div className='FooterItem' onClick={()=>navigate('/help')}>Help</div>
                </div>
            </div>
          
          <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'center',paddingBottom:'2.6em',paddingTop:'2.5em'}}>
            <img src={N3rveLogo} alt="Nerve Logo" style={{width:'4.78em',height:'0.875em'}}/>

            <div className='Copywrighttext'>&copy; 2024 N3RVE All Rights Reserved</div>
          
            
            <img src={InstagramLogo} alt="Instagram Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'2.5em'}}/>
            <img src={TwitterLogo} alt="Twitter Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/>
            <a href="https://discord.com/invite/kM4hkFC7zv" target="_blank" style={{textDecoration:'none'}}><img src={DiscordLogo} alt="Discord Logo" style={{height:'2.5em',width:'2.5em',marginLeft:'1em'}}/></a>
      
           
          </div>
        </div>
      </div>
       }
   

    </div>
  );
}

export default Footer;
